import { useEffect, useState } from 'react';
import { getSchoolStructure } from '../../../apis/schoolStrcuture';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { SchoolStructureProps } from '../../../types/schoolStructure';

export const useSchoolStructure = () => {
  const [activityGroupsOptions, setActivityGroupsOptions] = useState<
    { label: string; value: string }[] | undefined
  >([]);

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  useEffect(() => {
    const fetchSchoolStructure = async () => {
      const response = await getSchoolStructure(loggedInUser?.school);
      const schoolStructure = response as unknown as SchoolStructureProps;

      const activityGroupsDetails = schoolStructure.activityGroups?.map(
        (activity: string) => ({
          label: activity,
          value: activity
        })
      );
      setActivityGroupsOptions(activityGroupsDetails);
    };

    fetchSchoolStructure();
  }, [loggedInUser?.school]);

  return { activityGroupsOptions };
};
